import React from 'react';
import { srSubstitute } from '../../all-claims/utils';

export function obfuscate(str, numVisibleChars = 4, obfuscateChar = '*') {
  if (!str) {
    return '';
  }

  if (str.length <= numVisibleChars) {
    return str;
  }

  return (
    obfuscateChar.repeat(str.length - numVisibleChars) +
    str.substring(str.length - numVisibleChars, str.length)
  );
}

export function mask(value, numVisibleChars = 4) {
  if (!value) {
    return srSubstitute('', 'is blank');
  }
  const repeatCount = Math.max(value.length - numVisibleChars, 0);
  return (
    <span>
      {srSubstitute('●'.repeat(repeatCount), 'ending with')}
      {value.slice(-numVisibleChars)}
    </span>
  );
}

export function capitalizeFirstLetter(val) {
  if (!val) return '';
  return (
    String(val).charAt(0).toUpperCase() + String(val).slice(1).toLowerCase()
  );
}
